import { useContext, useState} from "react";
import { UserContext } from '../Context/UserContext';
import NotPremium from "./NotPremium";
import GameBar from "./GameBar";
import RatingDropDown from "./RatingDropDown";
import GoodHitterTrendsTable from "./GoodHitterTrendsTable";
import ColorLabels from "./ColorLabels";
import BadHitterTrendsTable from "./BadHitterTrendsTable";
import BatterIconLogo from "./BatterIconLogo";
import "../styles/hitterTrendsTable.css"
import FormattedDate from "./FormattedDate";

function HitterTrendsContainer() {
    const {isActiveSub} = useContext(UserContext);
    //console.log('singleHitterState', state.singleHitter)
    const [ratingTimeframe, setRatingTimeframe] = useState(false) //true is current season, false is default
    const [eliteGreateRatings, setEliteGreatRatings] = useState(true) //true is elite/great/above avg hitters, false is avg and poor hitters
    //const isUser = state.loggedIn ? true : false

    function handleChange() {
        setRatingTimeframe(prevTimeframe => !prevTimeframe)
    }

    function handleEliteGreatChange() {
        setEliteGreatRatings(prevEliteGreatRatings => !prevEliteGreatRatings)
    }

    if (isActiveSub)
    return (
        <div>
            <BatterIconLogo logoID={"trendsBattersBoxIconLogo"} />
            <h2 className="trendsHeader">MLB Hitter Trends for {<FormattedDate />}</h2>
            <GameBar />
            <RatingDropDown ratingTimeframe={ratingTimeframe} handleChange={handleChange}/>
            <div className="ratings-dropdown">
                <label>Select Trend: </label>
                <select onChange={handleEliteGreatChange} value={eliteGreateRatings ? "Over Trends" : "Under Trends"}>
                    <option>Over Trends</option>
                    <option>Under Trends</option>
                </select>
            </div>
            <div className="hitterTrendNotes">
                <li>Note: All trends are based on today's matchup rating category.</li>
                <li>Example: Number of games with an elite rating or strong rating, etc.</li>
            </div>
            <ColorLabels />
            <div className="hitterTrendsContainer">
                {eliteGreateRatings ? <GoodHitterTrendsTable ratingTimeframe={ratingTimeframe} /> : <BadHitterTrendsTable ratingTimeframe={ratingTimeframe} />}
            </div>
        </div>
    )
    else {
        return (
            <div className="userNotPremium">
                <NotPremium />
            </div>
            )
        }
}

export default HitterTrendsContainer